/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.emargement.ts
 *
 * Messages du bouton « Feuille d'émargement (PDF) » : espace animateur
 * (« Mes ateliers ») et back-office (ateliers, présence par atelier).
 * 2026-10-08, demande de Mika. Fusionné dans fr.ts. Le mot de l'activité
 * n'apparaît pas ici : le lexique de l'événement le pilote ailleurs.
 *
 * Mikael - chef de projet - 2026-10-08
 */
export const messagesEmargementFr: Record<string, string> = {
  'emargement.bouton': 'Feuille d’émargement (PDF)',
  'emargement.aria': 'Feuille d’émargement (PDF) : {titre}',
  'emargement.aide': 'À imprimer, ou à garder sur le téléphone en cas de coupure réseau.',
  'emargement.telechargee': 'Feuille d’émargement téléchargée : retrouvez-la dans vos fichiers.',
  'emargement.erreur': 'La feuille d’émargement n’a pas pu être téléchargée. Réessayez dans un instant.',
  'emargement.erreurDroits': 'Vous n’avez pas accès à cette feuille d’émargement.',
  'emargement.erreurSession': 'Votre session a expiré : reconnectez-vous, puis réessayez.',
  'emargement.horsLigne':
    'Vous êtes hors connexion : téléchargez la feuille quand le réseau revient. Déjà téléchargée, elle s’ouvre depuis vos fichiers.',
};
